import React from "react";
import ApmLink from "src/ui/shared/ApmLink";

import { Box, Typography } from "@mui/material";

interface Props {
    title: string;
    text: string;
}

const BasePage = (props: Props) => (
    <Box style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", width: "100%" }}>
        <div style={{ textAlign: "center" }}>
            <Typography variant="h4">{props.title}</Typography>
            <ApmLink href="https://emteria.com">
                <Typography variant="h6">{props.text}</Typography>
            </ApmLink>
        </div>
    </Box>
);

export const PageForbidden = () => <BasePage title="403 - Forbidden" text="Go to main page" />;
export const PageNotFound = () => <BasePage title="404 - Not Found" text="Go to main page" />;
